<template>
    <button v-for="item in btnItems" :key="item.key" :class="[item.key, `btn`, {active : item.isActive}, item.className]" @click="btnClickhandler(item.key)" ref="btnRefs">
        <span class="date-btn">{{ $t(item.value) }}</span>
    </button>
</template>

<script setup>
import { defineProps,defineEmits } from 'vue';

    const props = defineProps({
        isClickActive : Boolean,
        btnItems      : Array
    });

    const emit = defineEmits(["btnClick"]);
    const btnClickhandler = (key) => {
        if(props.isClickActive) {
            props.btnItems.forEach(item => item.isActive = false);
            props.btnItems.find(item => item.key === key).isActive = true;
        }

        emit("btnClick", {
            key,
            btnItems : props.btnItems
        });
    }
</script>

<style scoped>
    @import '@/assets/scss/components/ui/button.scss';
</style>